import {AgentMessageObject, BotMessageSendObject} from "../../types/chat";
import {isBotSendMessageObject} from "../utils/typeUtils";
import {MessageHistoryFactory} from "../factory/messageHistoryFactory";
import {ChatBotSummary} from "./chatBotSummary";
import {ResponseFactory} from "../factory/responseFactory";
import AbstractWebsocketChat from "../abstractWebsocketChat";
import {MessageSendState} from "../../types/enums";

export class ChatMessageHandler {

    private lastQuestion:string = '';
    private botMessageCheckTimerId: number | null = null;
    public hasSomeMessages = false;

    constructor( private chat: AbstractWebsocketChat ) {}

    public handleOnBotMessage = (event: MessageEvent): void => {
        let data = JSON.parse(event.data);
        if (data.class === 'History') {
            document.dispatchEvent(new CustomEvent('bot-history-loaded'));
            this.handleOnHistoryMessage(data);
            return;
        }

        if (this.botMessageCheckTimerId !== null) {
            clearTimeout(this.botMessageCheckTimerId);
            this.botMessageCheckTimerId = null;
        }

        if (data.class === 'Summary') {
            this.handleSummaryMessage(data);
            return;
        }

        let chatRequest = data.chatRequest;

        if (chatRequest === undefined) {
            this.chat.handleWebsocketError('chat Request not set', {
                messageType: 'BotMessage',
                reason: 'chatRequest undefined'
            });
            return;
        }

        let chatResponse = data.chatResponse;
        if (chatResponse === undefined) {
            this.chat.handleWebsocketError('chat Response not set', {
                messageType: 'BotMessage',
                reason: 'chatResponse undefined'
            });
            return;
        }

        this.chat.setAnswerContent(ResponseFactory.create(data.html, chatResponse.id, chatRequest.messageId));
    };
    public handleOnHistoryMessage = (data:any ): void => {
        let messageHistory = MessageHistoryFactory.create(data);
        if (messageHistory === null) {
            this.chat.showBotSuggestions();
            return;
        }
        
        if (messageHistory.count() === 0) {
            this.chat.showBotSuggestions();
        }

        this.chat.setHistoryContent(messageHistory);
    };

    public handleSummaryMessage = (data:any ): void => {
        if (!data.html || typeof data.html !== 'string' || data.html === '') {
            return;
        }

        let summary = new ChatBotSummary(data.html);
        this.chat.setBotSummary(summary);
    };

    public handleOnAgentMessage(data: any): void
    {
        if(data.class === "SessionTimeoutError") {
            this.chat.closeConnection().then( () => {
                this.chat.closeChatByAgent().then(() => {
                    return;
                });
            });
            return;
        }

        if(data.class === "ApiErrorResponse") {
            this.chat.getChatConnector().closeConnection().then(() => {
                return;
            } );
            return;
        }

        if(data.code === undefined || data.code !== 200) {
            let reasonText = 'code '+data.code+' invalid';
            if (data.message) {
                reasonText += " // " + data.message;
            }
            this.chat.handleWebsocketError('invalid onAgentMessageCode', {
                messageType: 'AgentMessage',
                reason: reasonText,
            });
            return;
        }

        if (data.originatingEntity && data.originatingEntity === 'Human') {
            this.hasSomeMessages = true;
        }

        if (data.class === 'History') {
            this.handleOnHistoryMessage(data);
            this.chat.setHistoryLoaded();
            return;
        }

        this.chat.setAnswerContent(ResponseFactory.create(data.text, '', '', data.sender, data.time));
        this.chat.updateDisconnectTimer();
    }

    public handleSendMessage = (
        chatWebSocket: WebSocket|null,
        messageObject: BotMessageSendObject|AgentMessageObject,
        onError: () => void
    ): void =>
    {
        if (chatWebSocket === null) {
            onError();
            return;
        }

        let className = 'Message';
        let isBotMessage = isBotSendMessageObject(messageObject);
        let messageText = isBotSendMessageObject(messageObject) ? messageObject.messageText : messageObject.text;
        if(isBotMessage) {
            className = messageObject.class;
        }

        if (!this.shouldMessageBeSend(messageText, className)) {
            return;
        }

        chatWebSocket.send(JSON.stringify(messageObject));
        if (!isBotMessage) {
            this.chat.changeMessageStatus(messageObject.messageId, MessageSendState.SEND);
        }

        if(!this.chat.isAgentChat()) {
            this.botMessageCheckTimerId = setTimeout(() => {
                this.botMessageCheckTimerId = null;
                onError();
            }, 60000);
        }
    }

    public handleSendMessageError= (webSocket: WebSocket|undefined = undefined): void =>
    {
        this.chat.handleWebsocketError('send Message error', {
            messageType: 'SendMessage',
            reason: 'Timeout oder keine Antwort',
            websocket: webSocket
        });
    }

    private shouldMessageBeSend( message: string, className: string): boolean {
        if (className == 'Summary') {
            return true;
        }

        if (this.lastQuestion === message) {
            return false;
        }

        if (!message) {
            return false;
        }

        this.lastQuestion = message;
        return true;
    }
}